export const LOADING_BANK = "LOADING_BANK";
export const GET_BANK_LIST = "GET_BANK_LIST";
export const ADD_BANK = "ADD_BANK";
export const REMOVE_BANK = "REMOVE_BANK";
export const UPDATE_BANK = "UPDATE_BANK";
export const GET_BANK_ID = "GET_BANK_ID";
